import React from 'react';
import { Loading } from '@avila-tek/ui/src';

function LoadingShopCart() {
  return (
    <div className="absolute w-full h-full bg-slate-50 opacity-75 z-50">
      <Loading />
    </div>
  );
}

export default LoadingShopCart;
